import React from 'react';

interface ButtonProps {
  onClick: () => void;
  text?: string;
  className?: string;
  size: string;
  variant: string;
  disabled?: boolean;
  iconUrl?: string;
  icon?: string;
  iconPosition?: 'left' | 'right';
  ariaLabel?: string;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  text,
  className,
  size,
  variant,
  disabled = false,
  iconUrl = undefined,
  icon = undefined,
  iconPosition = 'right',
  ariaLabel = undefined,
}) => {
  return (
    <button
      className={`${className || ''} ${getButtonClasses(size, variant, disabled)}`}
      onClick={onClick}
      aria-label={ariaLabel}
      disabled={disabled}>
      {icon && iconPosition === 'left' && <i className={`icon icon-${icon}`}></i>}
      {iconUrl && iconPosition === 'left' && <img src={iconUrl} alt={ariaLabel ?? ''}></img>}
      {text}
      {iconUrl && iconPosition === 'right' && <img src={iconUrl} alt={ariaLabel ?? ''}></img>}
      {icon && iconPosition === 'right' && <i className={`icon icon-${icon}`}></i>}
    </button>
  );
};

const getButtonClasses = (size: string, variant: string, disabled: boolean): string => {
  return ['pdq-button', `pdq-button--${size}`, `pdq-button--${variant}`, disabled ? 'disabled' : ''].join(' ');
};

export default Button;
